import {
  Product,
  ProductColumnsIds,
  ProductDetailsTabsIds
} from '@setvi/shared/interfaces';
import { ProductName } from 'componentsV2';
import { UseProductColumnsProps } from '.';
import {
  Cost,
  Discount,
  Family,
  LeadTime,
  Line,
  Manufacturer,
  Price,
  Profit,
  Size,
  StockContent
} from './contents';
import { PriceButton } from '../../price-button';

interface GetProductColumnsProps
  extends Omit<UseProductColumnsProps, 'configColumns'> {
  product: Product;
  id: ProductColumnsIds;
}

export const getProductColumns = ({
  id,
  product,
  selectedCustomer,
  productPricesLoading,
  searchQuery,
  stockRefresh,
  onGetProductPrice,
  updateProduct,
  openProductDetails,
  onPromotionClick
}: GetProductColumnsProps) => {
  const contents: Record<ProductColumnsIds, JSX.Element | undefined> = {
    [ProductColumnsIds.ProductName]: (
      <ProductName
        product={product}
        searchQuery={searchQuery}
        onPromotionClick={onPromotionClick}
        onSalesEnablementClick={i =>
          openProductDetails(i, ProductDetailsTabsIds.SALES_ENABLEMENT)
        }
      />
    ),
    [ProductColumnsIds.Manufacturer]: <Manufacturer product={product} />,
    [ProductColumnsIds.Stock]: (
      <StockContent
        product={product}
        stockRefresh={stockRefresh}
        selectedCustomer={selectedCustomer}
        updateProduct={updateProduct}
        onClick={i => openProductDetails(i, ProductDetailsTabsIds.WAREHOUSE)}
      />
    ),
    [ProductColumnsIds.LeadTime]: <LeadTime product={product} />,
    [ProductColumnsIds.Price]: (
      <Price value={product?.price} loading={productPricesLoading} />
    ),
    [ProductColumnsIds.ListPrice]: <Price value={product?.price} />,
    [ProductColumnsIds.GetPrice]: (
      <PriceButton
        price={product?.price}
        onGetPrice={() => onGetProductPrice([product])}
      />
    ),
    [ProductColumnsIds.Cost]: (
      <Cost value={product?.cost} loading={productPricesLoading} />
    ),
    [ProductColumnsIds.GetCost]: (
      <Cost value={product?.cost} loading={productPricesLoading} />
    ),
    [ProductColumnsIds.CustomerCost]: (
      <Cost value={product?.cost} loading={productPricesLoading} />
    ),
    [ProductColumnsIds.GP]: (
      <Profit
        price={product?.price}
        cost={product?.cost}
        loading={productPricesLoading}
      />
    ),
    [ProductColumnsIds.Discount]: (
      <Discount
        price={product?.price}
        cost={product?.cost}
        loading={productPricesLoading}
      />
    ),
    [ProductColumnsIds.Family]: <Family product={product} />,
    [ProductColumnsIds.Line]: <Line product={product} />,
    [ProductColumnsIds.Size]: <Size product={product} />
  };

  return contents[id];
};
